import _ from 'underscore';
import {
  JSDataCacheManager,
  CascadeInvalidateStrategy,
  WriteActionInvalidateStrategy,
  PartitionStrategy,
} from '@bingads-webui-universal/js-data-cache-manager';

import {
  TimeAwareCache,
  LRUReplacementStrategy,
} from '@bingads-webui-universal/time-aware-cache';
import { dependants } from '@bingads-webui/campaign-entity-dependants';

import { DecoratedODataAdapter } from './decorated-odata-adapter';
import { ContextManagerBridge } from './context-manager-bridge';

const ADDITIONAL_WRITE_ACTIONS = ['createMany', 'updateMany'];
const RESOURCE_WHITE_LIST = [
  'Account',
  'Ad',
  'AdGroup',
  'AdGroupCriterion',
  'AssetLink',
  'Campaign',
  'CampaignCriterion',
  'CustomColumn',
  'DimensionRow',
  'FeedItem',
  'Keyword',
  'NegativeKeyword',
  'PerformanceTarget',
  'PerformanceTargetInstance',
  'PerformanceTimeSeries',
  'SearchTerm',
  'Tip',
  'DsaSearchTerm',
  'DsaTarget',
  'NegativeAdGroupDsaTarget',
  'NegativeCampaignDsaTarget',
  'AdCustomizerAttribute',
  'AssetGroup',
];

export class CampaignCacheManager extends JSDataCacheManager {
  /**
   * JSDataCacheManager for Campaign UI
   * @param {Object} options -
   * @param {JSDataStore} options.store - The JSData store
   * @param {ContextManager} options.contextManager - The campaign context manager
   * @param {function} options.getTTL - Callback to get TTL for cache items
   */
  constructor({ store, contextManager, getTTL }) {
    super({
      store,
      actions: ADDITIONAL_WRITE_ACTIONS,
      invalidateStrategies: [
        new WriteActionInvalidateStrategy({
          writeActions: ADDITIONAL_WRITE_ACTIONS,
        }),

        new CascadeInvalidateStrategy({ dependants }),
      ],
      partitionStrategies: [
        new PartitionStrategy({
          cache: new TimeAwareCache({
            // Default TTL 2 hours
            ttl: 2 * 60 * 60 * 1000,

            // Default limit 200 items
            strategy: new LRUReplacementStrategy({ limit: 200 }),
          }),
          condition(cache, { resource }) {
            return _.contains(RESOURCE_WHITE_LIST, resource);
          },
        }),
      ],
    });

    this.enableCacheOnAdapter('odata', adapter => new DecoratedODataAdapter({
      adapter,
      getTTL,
    }));
    this.contextManagerBridge = new ContextManagerBridge({
      cacheManager: this,
      contextManager,
    });
  }
}
